module.exports = __webpack_public_path__ + "img/1722485784607-WhatsApp Image 2024-08-01 at 12.12.24.jpeg.2795f6eb.webp";